module.exports = "/*\n * @Author: Jon Lucas \n * @Date: 2017-11-07 14:47:58 \n * @Last Modified by:   Jon Lucas \n * @Last Modified time: 2017-11-07 14:47:58 \n */\ncanvas#threed-canvas {\n  width: 100%;\n  height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-view/building-customization/threed-view/threed-view.component.scss
// module id = ./src/app/main-view/building-customization/threed-view/threed-view.component.scss
// module chunks = main